import * as React from 'react';
import { Field, Form } from 'react-final-form';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import { useTranslation } from 'react-i18next';
import { BaseButton, Tooltip, ModalX } from '../../../../../BaseComponents';
import { useConfig } from '../../../../../context';
import { useTheme } from '../../../../../theme';
import { SafeHtml } from '@shared/ui';
let lastVisibleError = '';
const AcceptCheckinRules = ({ isOpen, onClose, classes, onSubmit, rules }) => {
    const { AcceptCheckinRules: css } = useTheme('Features').StartCheckIn;
    const { t } = useTranslation('CheckinRules');
    const { global: { companyInfo: { iataCode } } } = useConfig();
    if (iataCode === 'N4') {
        return null;
    }
    return (React.createElement(ModalX, { isOpen: isOpen, onClose: onClose, classes: classes, size: "medium" },
        React.createElement("div", { className: css.rules },
            React.createElement("h3", { className: css.rules__title }, t('Terms & Conditions')),
            React.createElement(SafeHtml, { tag: "div", className: css.rules__text, html: rules }),
            React.createElement(Form, { onSubmit: onSubmit }, ({ handleSubmit }) => (React.createElement("form", { className: css.rules__footer, onSubmit: handleSubmit },
                React.createElement(Field, { type: "checkbox", name: "agree", initialValue: false, validate: value => {
                        if (!value) {
                            return t('Please read and accept the online check-in terms and conditions');
                        }
                    } }, ({ meta, input }) => {
                    if (meta.error) {
                        lastVisibleError = meta.error;
                    }
                    return (React.createElement(FormControlLabel, { classes: {
                            label: css.rules__label
                        }, control: React.createElement(Tooltip, { open: meta.submitFailed && !input.value, title: lastVisibleError, placement: "top-start" },
                            React.createElement(Checkbox, { color: "primary", classes: {
                                    colorPrimary: css.rules__checkbox,
                                    checked: css.rules__checkbox_checked
                                }, checked: input.checked, inputProps: Object.assign({}, input) })), label: React.createElement("span", { dangerouslySetInnerHTML: {
                                __html: t('I have read and agreed to the online check-in terms and conditions')
                            } }) }));
                }),
                React.createElement(BaseButton, { type: "submit", variant: "action", className: css.rules__button }, t('Continue'))))))));
};
export default AcceptCheckinRules;
